import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { setStoredLocale } from '../i18n';

export function useLocale() {
  const { i18n } = useTranslation();
  const locale = i18n.language;

  const setLocale = useCallback(
    (next) => {
      setStoredLocale(next);
      i18n.changeLanguage(next);
    },
    [i18n]
  );

  return {
    locale,
    isRtl: locale === 'ar',
    setLocale,
    toggleLocale: () => setLocale(locale === 'ar' ? 'en' : 'ar'),
  };
}
